//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import Alerta from '../../../../../util/snackbars/.mixins/';
import FormPerfil from '../childrens/FormPerfil/.mixins/FormPerfil';
import Error from "../../../../../util/error/.mixins/Error";

// controllers
import Pessoa_controller from '../../../../../../controllers/pessoa';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

export default class Perfil extends Component {

  constructor(props) {
    super(props);

    this.child = React.createRef();

    this.state = {
      codigo: '',
      nome: '',
      senha: '',
      validoNome: true,
      validoSenha: true,
      isLoading: true,
      isError: false,
      error: null
    }

    //binds
    this.editData = this.editData.bind(this);
    this.setState = this.setState.bind(this);

  }

  UNSAFE_componentWillMount() {
    //carregamento de dados nos campos
    this.loadData(this);
  }

  componentDidMount() {
    // TagManager.dataLayer({
    //     dataLayer: {
    //       event: 'event',
    //       eventCategory: 'tokstok:fornecedores:perfil',
    //       eventAction: 'componentDidMount',
    //       eventLabel: 'componente-perfil',
    //     }
    // });

    //auditoria
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    Log.info(token, "Efetuado carregamento da tela Perfil!");
  }

  async loadData(props) {

    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      var o_pessoa = await Pessoa_controller.getByToken(token);
      var j_pessoa = JSON.parse(o_pessoa.body);
      if (o_pessoa.res.statusCode === 200) {
        var obj = j_pessoa.itens;
        this.setState({
          codigo: obj.codigo,
          nome: obj.nome,
          senha: ''
        });

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:perfil',
        //       eventAction: 'callback',
        //       eventLabel: `sucesso:${obj.codigo}-${obj.nome}`,
        //     }
        // });

        //auditoria
        var str = "Efetuada requisição para retorno de dados de perfil! "
          + "Response:( Method: " + o_pessoa.res.request.method
          + ", StatusCode: " + o_pessoa.res.statusCode
          + ", Body: (limited 100chars)" + o_pessoa.body.substr(0, 100)
          + " )";
        Log.info(token, str);
      } else {
        throw new Error("Campos necessários, não foram retornados pelo servidor!");
      }
    } catch (error) {
      props.child.current.retorno('Erro ao carregar dados!', 'error');
      var errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        error: errorString,
        isError: true,
        isLoading: false
      });

      // TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'event',
      //       eventCategory: 'tokstok:fornecedores:perfil',
      //       eventAction: 'callback',
      //       eventLabel: `erro:${error.message}`,
      //     }
      // });

      //auditoria
      var str = "Erro no retorno de dados de perfil! "
        + "Error:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
    }

  }

  async editData() {

    //validacoes
    if (this.state.nome === '' || this.state.nome == null)
      return this.child.current.retorno('Preencha o campo nome!', 'error');

    if (this.state.senha === '' || this.state.senha == null)
      return this.child.current.retorno('Preencha o campo senha!', 'error');

    if (this.state.nome.length < 3)
      return this.setState({ validoNome: false });
    else
      this.setState({ validoNome: true });

    if (this.state.senha.length < 6 || this.state.senha.length > 10)
      return this.setState({ validoSenha: false });
    else
      this.setState({ validoSenha: true });

    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {

      var data = {
        codigo: this.state.codigo,
        nome: this.state.nome,
        senha: this.state.senha
      };
      const o_pessoa = await Pessoa_controller.editPerfil(data, token);
      var j_pessoa = JSON.parse(o_pessoa.body);

      console.log(j_pessoa.status, j_pessoa.message)

      if (j_pessoa.status) {
        this.child.current.retorno('Dados editados com sucesso!', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        //auditoria
        var str = "Efetuada requisição para envio de dados de perfil! "
          + "Response:( Method: " + o_pessoa.res.request.method
          + ", StatusCode: " + o_pessoa.res.statusCode
          + ", Body: (limited 100chars)" + o_pessoa.body.substr(0, 100)
          + " )";
        Log.info(token, str);
      } else {
        this.child.current.retorno(j_pessoa.message, 'error');
      }
    } catch (error) {
      this.child.current.retorno(error.message, 'error');
      //auditoria
      var str = "Erro no envio de dados de perfil! "
        + "Error:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
    }

  }

  render() {
    return (
      <div>
        {!this.state.isError &&
          <FormPerfil {...this} />
        }
        {this.state.isError &&
          <div className={'container'} align="center">
            <Error text={this.state.error} />
          </div>
        }
        <Alerta ref={this.child} />
      </div>
    );
  }

}